module.exports = __webpack_public_path__ + "7f01e3986479e771c7b3d8d79e17d1b6.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/icons/cursors/circles/svg/circle-60.svg
// module id = 588
// module chunks = 0